var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOutOfOffice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6544_104774",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6544_104774)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 14V2H10.0248V14H6.80165V10.6667H4.22314V14H1ZM3.57851 8.66667H4.86777V7.33333H3.57851V8.66667ZM3.57851 6H4.86777V4.66667H3.57851V6ZM6.15703 8.66667H7.44628V7.33333H6.15703V8.66667ZM6.15703 6H7.44628V4.66667H6.15703V6ZM12.9256 10.3333L12.0231 9.4L12.7161 8.66667H10.6694V7.33333H12.7161L12.0231 6.6L12.9256 5.66667L15.1818 8L12.9256 10.3333Z",
    fill: "#4CAF50"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutOfOffice);
export default __webpack_public_path__ + "static/media/out-of-office.86d1348e4e60896f04ceaa81dad5496d.svg";
export { ForwardRef as ReactComponent };